module.exports = __webpack_public_path__ + "static/media/WBN_TIP.b1e5e805.png";